<template>
  <div class="position-relative">
    <BaseTopLine> </BaseTopLine>

    <div class="tw-flex tw-justify-center tw-mb-[20px] tw-px-[26px] tw-bg-[#ECF3FE]">
      <img
        :src="require(`@/assets/images/614_banner_4.webp`)"
        class="tw-w-full tw-max-w-[1290px] tw-mx-auto"
      />
    </div>

    <div
      class="tw-bg-main2 tw-py-[10px] tw-px-[20px] tw-rounded-[6px] tw-mx-[26px] tw-text-[12px] tw-mb-[20px] tw-flex tw-justify-center tw-sticky tw-top-[146px]"
    >
      <div
        class="tw-flex tw-items-end tw-gap-[20px] tw-text-white tw-max-w-[1227px] tw-w-full"
      >
        <div
          class="tw-app-input-container multiselect-type-1 !tw-max-w-[200px]"
        >
          <label class="tw-app-input-container-label">Город</label>
          <BaseSelect
            placeholder=""
            selectLabel=""
            deselectLabel=""
            v-model="currentCity"
            label="cities__name"
            :options="citiesList"
          >
            <template slot="noOptions">{{ dataLang["select_empty"] }}</template>
            <template slot="noResult">{{
              dataLang["select_search_empty"]
            }}</template>
            <template slot="selectedLabel">{{
              dataLang["select_selected"]
            }}</template>
            <template slot="deselectLabel">{{
              dataLang["select_unselect"]
            }}</template>
          </BaseSelect>
        </div>

        <div class="tw-app-input-container">
          <label class="tw-app-input-container-label"
            >Напишите, что нужно. Например: “ОСАГО”</label
          >
          <input
            @keyup.enter="onSearch"
            class="tw-app-input-dark"
            type="text"
            v-model="searchString"
            placeholder=""
          />
        </div>

        <div class="tw-flex tw-flex-row">
          <button @click="onSearch" type="button" class="tw-app-btn-primary">
            Найти
          </button>
          <button @click="onClear" type="button" class="tw-app-btn-light">
            Сбросить
          </button>
        </div>
      </div>
    </div>

    <!-- <div class="my-20 d-flex justify-content-center">
      <div class="d-flex justify-content-center align-items-center gap-60">
        <div
          class="text-decoration-underline cursor-pointer fsc-14"
          @click="$modal.show('citiesModal')"
        >
          {{ currentCity?.cities__name }}
        </div>
        <div class="suppliers-input">
          <input
            type="text"
            v-model="searchString"
            placeholder="Напишите, что нужно. Например: “ОСАГО”"
          />
          <div class="suppliers-input__controls">
            <svg
              width="16"
              @click="onClear"
              @keyup.enter="onClear"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.82202 6.40781L14.186 0.0438488L15.6099 1.46781L9.24598 7.83177L15.6538 14.2396L14.2396 15.6538L7.83177 9.24598L1.46781 15.6099L0.0438488 14.186L6.40781 7.82202L0 1.41421L1.41421 0L7.82202 6.40781Z"
                fill="#666666"
              />
            </svg>

            <svg
              width="32"
              @click="onSearch"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="32" height="32" rx="16" fill="#F6EE25" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.0513 8.89768L13.9489 7L22.9489 16L13.9489 25L12.0513 23.1023L19.1536 16L12.0513 8.89768Z"
                fill="black"
              />
            </svg>
          </div>
        </div>
      </div>
    </div> -->

    <div
      class="d-flex gap-20 flex-column mx-auto pb-30"
      style="max-width: 1227px"
    >
      <div
        class="d-flex gap-10 flex-column"
        v-for="value in searchResultOfCalc"
        :key="value.b2b_product_groups__id"
      >
        <div class="tw-text-[18px] tw-text-forTitle tw-font-[600]">
          {{ value.b2b_product_groups_description__name }}
        </div>
        <div class="d-flex gap-15 flex-wrap">
          <div
            v-for="product in value.products"
            :key="product.b2b_products__id"
            class="d-flex flex-column product-card"
            @click="() => onClickProduct(product)"
          >
            <div
              class="d-flex flex-column justify-content-between flex-grow-1"
              :style="{
                'background-color': computedBg(product.b2b_products__group_id),
              }"
            >
              <div class="px-15 py-15 w-full d-flex flex-column gap-5">
                <div
                  class="fw-medium"
                  style="min-height: 40px; line-height: 20px"
                >
                  {{ product.b2b_products_description__name }}
                </div>
                <div
                  class="fsc-12"
                  style="min-height: 36px;"
                  v-html="product.b2b_products_description__description"
                ></div>
                <div
                  class="tw-font-bold"
                  v-html="product.b2b_products_description__price_text"
                ></div>
              </div>
              <img
                class="w-full"
                :src="
                  require(`@/assets/images/suppliers/${product.b2b_products__id}.png`)
                "
                alt=""
              />

              <div
                class="tw-mt-[5px] tw-flex tw-gap-[5px] tw-items-center tw-bg-[#FDD579] tw-p-[4px_12px] tw-text-[11px] tw-leading-[13px] tw-font-bold tw-mx-[15px] tw-mb-[15px] tw-rounded-[15px]"
              >
                <img
                  class="tw-h-[20px]"
                  :src="require(`@/assets/images/coin.webp`)"
                />
                Возврат 1% баллами
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <BaseModal
      name="citiesModal"
      width="420"
      height="312"
      @before-close=""
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      classes="bg-transparent shadow-none"
    >
      <div class="bg-white rounded-25 pt-20 pb-20 px-30 h-100">
        <div class="d-flex justify-content-end">
          <button
            type="button"
            class="btn-close"
            @click="$modal.hide('citiesModal')"
          ></button>
        </div>
        <div class="d-flex h-100 flex-column justify-content-center pb-10">
          <p class="text-center fw-semi-bold mb-15 wp-100">Город</p>
          <BaseSelect
            style="width: 100%"
            :maxHeight="110"
            placeholder=""
            selectLabel=""
            deselectLabel=""
            v-model="currentCity"
            label="cities__name"
            :options="citiesList"
          >
            <template slot="noOptions">{{ dataLang["select_empty"] }}</template>
            <template slot="noResult">{{
              dataLang["select_search_empty"]
            }}</template
            ><template slot="selectedLabel">{{
              dataLang["select_selected"]
            }}</template>
            <template slot="deselectLabel">{{
              dataLang["select_unselect"]
            }}</template>
          </BaseSelect>
          <!-- <div class="d-flex gap-5" v-if="typeOpenCancel == 'client'"> -->
          <!-- <BaseInputNew placeholder="Код" style="width: 100%" @input="(data) => (codeFromSms = data.value)"
              inputClass="" inputName="clients__name" value="" nameSign="" /> -->
          <!-- </div> -->

          <div class="d-flex justify-content-center mt-15 gap-15">
            <div
              class="base-button base-button--action fsc-14 px-20 text-uppercase"
              @click="$modal.hide('citiesModal')"
            >
              Отменить
            </div>
            <div
              class="btn btn-sm btn-primary action-hover fsc-14 px-20 text-uppercase"
              @click="$modal.hide('citiesModal')"
            >
              Выбрать
            </div>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="orderSendModalLegacy"
      width="420"
      height="auto"
      @before-close="clearFields"
      @before-open="beforeOpen"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      classes="bg-transparent shadow-none"
    >
      <div
        class="bg-white rounded-25 pt-20 pb-20 px-30 h-100 position-relative"
      >
        <BaseLoader v-if="localLoadingOrder"></BaseLoader>
        <!-- <div class="d-flex justify-content-end">
          <button type="button" class="btn-close" @click="$modal.hide('citiesModal')"></button>
        </div> -->
        <div class="d-flex h-100 flex-column justify-content-center pb-10">
          <p class="text-center fw-semi-bold mb-15 wp-100">Оформление заказа</p>
          <div class="text-muted fsc-14 mb-10">
            <div class="mb-10">Город: {{ currentCity?.cities__name }}</div>
            <div>
              Товар / услуга:
              {{ currentSelectProduct?.b2b_products_description__name }}
            </div>
          </div>
          <div class="mb-10">
            <div class="text-muted fsc-14">
              <div class="mb-5">Для какого объекта (по желанию)</div>
            </div>
            <BaseSelect
              style="width: 100%"
              :customLabel="
                ({ vehicles__name, vehicles__gosnumber, vehicles__id }) => {
                  return vehicles__id
                    ? `${vehicles__name} ${vehicles__gosnumber}`
                    : vehicles__name;
                }
              "
              :maxHeight="130"
              deselectLabel=""
              noOptions=""
              noResult=""
              selectedLabel=""
              placeholder="Не выбрано"
              selectLabel=""
              v-model="objectSelected"
              :options="objectList"
            >
            </BaseSelect>
          </div>

          <div class="mb-10">
            <div class="text-muted fsc-14">
              <div class="mb-5">
                Собственник <br />
                (при оформлении полиса для страховой)
              </div>
            </div>
            <BaseSelect
              style="width: 100%"
              label="label"
              :maxHeight="130"
              deselectLabel=""
              noOptions=""
              noResult=""
              selectedLabel=""
              placeholder="Не выбрано"
              selectLabel=""
              v-model="ownerSelected"
              :options="ownerList"
            >
            </BaseSelect>
          </div>

          <div class="mb-10">
            <div class="text-muted fsc-14">
              <div class="mb-5">
                Страхователь <br />
                (при оформлении полиса для страховой)
              </div>
            </div>
            <BaseSelect
              style="width: 100%"
              label="label"
              :maxHeight="130"
              deselectLabel=""
              noOptions=""
              noResult=""
              selectedLabel=""
              placeholder="Не выбрано"
              selectLabel=""
              v-model="strahSelected"
              :options="ownerList"
            >
            </BaseSelect>
          </div>

          <div class="mb-10">
            <div class="text-muted fsc-14">
              <div class="mb-5">Больше деталей заказа (по желанию)</div>
            </div>
            <BaseTextarea
              placeholder=""
              class="wp-100 fsc-14 mb-5"
              input-name="text"
              @onInput="(e) => (moreDetailString = e.value)"
              :minHeight="'120'"
              inputClass="fsc-11"
              name-sign=""
              :value="moreDetailString"
            >
            </BaseTextarea>
          </div>

          <div class="d-flex justify-content-center mt-15 gap-15">
            <div
              class="base-button base-button--action fsc-14 px-20 text-uppercase"
              @click="$modal.hide('orderSendModalLegacy')"
            >
              Отменить
            </div>
            <div
              class="btn btn-sm btn-primary action-hover fsc-14 px-20 text-uppercase"
              @click="onSaveOrder"
            >
              Заказать
            </div>
          </div>
        </div>
      </div>
    </BaseModal>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import GeneralService from "@/api/GeneralService";
import { computed } from "vue";

export default {
  components: {},

  data() {
    return {
      suppliersGroups: [],
      suppliersList: [],
      resultOfCalc: [],
      searchResultOfCalc: [],
      searchString: "",
      citiesList: [],
      currentCity: [],
      currentSelectProduct: null,
      objectList: [],
      objectSelected: [],
      ownerList: [],
      ownerSelected: [],
      strahList: [],
      strahSelected: [],
      moreDetailString: "",
      localLoadingOrder: false,
    };
  },
  methods: {
    beforeOpen() {
      this.objectSelected = this.objectList[0];
      this.ownerSelected = this.ownerList[0];
      this.strahSelected = this.ownerList[0];

      // return vehicles__id
      //           ? `${vehicles__name} ${vehicles__gosnumber}`
      //           : vehicles__name;
      //       }
      //         " :maxHeight="130" deselectLabel="" noOptions="" noResult="" selectedLabel="" placeholder="Не выбрано"
      //         selectLabel="" v-model="objectSelected" :options="objectList">
    },
    clearFields() {
      this.objectSelected = [];
      this.ownerSelected = [];
      this.strahSelected = [];
      this.moreDetailString = "";
    },

    onSaveOrder() {
      this.localLoadingOrder = true;
      GeneralService.editOrCreate("/b2b-orders/type1", {
        b2b_orders__b2b_product_id: this.currentSelectProduct.b2b_products__id,
        b2b_orders__city_id: this.currentCity.cities__id,
        object_id: Number(this.objectSelected.vehicles__id),
        owner_id: Number(this.ownerSelected.value),
        policyholder_id: Number(this.strahSelected.value),
        b2b_orders__buyer_comment: this.moreDetailString,
      })
        .then((data) => {
          this.$toast.success(data.data?.message);
        })
        .catch((e) => {
          console.log(e);
          this.$toast.error(e.response.data.message);
        })
        .finally(() => {
          this.clearFields();
          this.localLoadingOrder = false;
          this.$modal.hide("orderSendModalLegacy");
        });
    },

    onClickProduct(product) {
      this.currentSelectProduct = product;
      this.$modal.show("orderSendModal", {
        productId: product.b2b_products__id,
        productName: product.b2b_products_description__name,
        cityId: this.currentCity?.cities__id,
      });
    },

    onClear() {
      this.searchString = "";
      this.searchResultOfCalc = this.resultOfCalc;
    },

    onSearch() {
      if (this.searchString.length) {
        GeneralService.get(`/products`, {
          params: {
            where: JSON.stringify([
              {
                field: "b2b_products_description__name",
                value: `;percent;${this.searchString};percent;`,
                operator: "like",
              },
            ]),
          },
        })
          .then((data) => {
            // this.searchResultOfCalc = data.data.data.rows.reverse()
            let resOdCalc = [];
            this.suppliersGroups.forEach((el) => {
              if (
                !!data.data.data.rows.find(
                  (i) => el.b2b_product_groups__id == i.b2b_products__group_id
                )
              ) {
                resOdCalc.push({
                  ...el,
                  products: data.data.data.rows
                    .filter(
                      (i) =>
                        el.b2b_product_groups__id == i.b2b_products__group_id
                    )
                    .reverse(),
                });
              }
            });
            this.searchResultOfCalc = resOdCalc;
          })
          .catch((e) => {
            this.$toast.error("Неизвестная ошибка при поиске", {
              duration: 5000,
            });
          });
      }
    },

    computedBg(id) {
      let ids = Number(id);
      switch (ids) {
        case 1:
          return "#FEFDE5";
        case 2:
          return "#FFE9FB";
        case 3:
          return "#F1FFE6";
        case 4:
          return "#E9F3FF";
        case 5:
          return "#FFE3DC";
        case 6:
          return "#DBFEFF";
      }
    },

    loadData() {
      this.localLoading = true;
      Promise.all([
        GeneralService.get("/object-owners/select/list", {
          params: {
            limit: 3000,
          },
        })
          .then((data) => {
            this.ownerList = data.data.data.map((x) => {
              return {
                label: Object.values(x)[0],
                value: Object.keys(x)[0],
              };
            });

            this.ownerList.unshift({
              label: "Не выбрано",
              value: null,
            });
          })
          .catch((e) => {
            console.log(e);
          }),
        GeneralService.get(`/objects`, { params: { limit: 10000 } })
          .then((data) => {
            this.objectList = data.data.data.rows;
            this.objectList.unshift({
              vehicles__name: "Не выбрано",
              vehicles__id: null,
              vehicles__gosnumber: null,
            });

            // vehicles__id
            //                 ? `${vehicles__name} ${vehicles__gosnumber}`
            //                 : vehicles__name;
          })
          .catch((e) => {
            console.error(e);
          }),
        GeneralService.get(`/cities`, { params: { limit: 10000 } })
          .then((data) => {
            this.citiesList = data.data.data.rows;
            this.currentCity = this.citiesList.find(
              (x) => x.cities__id == this.userSetting.company_default_city_id
            );
          })
          .catch((e) => {
            console.error(e);
          }),

        GeneralService.get(`/products/groups`, {
          params: {
            limit: 10000,
          },
        })
          .then((data) => {
            this.suppliersGroups = data.data.data.rows.reverse();
          })
          .catch((e) => {
            this.$toast.error("Неизвестная ошибка при загрузке поставщиков", {
              duration: 5000,
            });
          }),
      ]).then(() => {
        GeneralService.get(`/products`, {
          params: {
            limit: 10000,
          },
        })
          .then((data) => {
            this.suppliersList = data.data.data.rows;

            this.suppliersGroups.forEach((el) => {
              if (
                !!this.suppliersList.find(
                  (i) => el.b2b_product_groups__id == i.b2b_products__group_id
                )
              ) {
                this.resultOfCalc.push({
                  ...el,
                  products: this.suppliersList
                    .filter(
                      (i) =>
                        el.b2b_product_groups__id == i.b2b_products__group_id
                    )
                    .reverse(),
                });
              }
            });

            this.searchResultOfCalc = this.resultOfCalc;
            console.log(this.resultOfCalc);

            this.localLoading = false;
          })
          .catch((e) => {
            this.$toast.error(
              "Неизвестная ошибка при загрузке группы поставщиков",
              { duration: 5000 }
            );
          });
      });
    },
  },
  mounted() {},
  beforeMount() {},
  created() {
    this.loadData();
  },
  computed: {
    ...mapState("userSettingModule", ["userSetting"]),
    ...mapState("translationModule", ["dataLang"]),
  },
};
</script>

<style lang="scss">
.product-card {
  width: 100%;
  max-width: 192px;
  // border: 1px solid #f5f5f5;
  border: 1px solid transparent;
  overflow: hidden;
  transition: 0.2s ease;
  border-radius: 15px;
  cursor: pointer;
}

.product-card:hover {
  box-shadow: 0px 24px 7px 0px #00000000;
  border-color: #0c63aa;
}

.suppliers-input {
  width: 600px;
  height: 50px;
  border-radius: 25px;
  border-width: 1px;
  padding-top: 6px;
  padding-right: 15px;
  padding-bottom: 6px;
  padding-left: 15px;
  border: 1px solid #e7e7e7;
  box-shadow: 1px 0px 2px 0px #b5b5b51a;
  display: flex;
  align-items: center;

  input {
    flex: 1;
    display: block;
    border: 0;
    outline: 0;
    font-size: 14px;
  }

  input::placeholder {
    color: #666666;
  }

  &__controls {
    display: flex;
    align-items: center;
    gap: 15px;
    cursor: pointer;
  }
}
</style>
